module.exports = __webpack_public_path__ + "media/components/assets/icons/kakao-53f1f6e9761a9edde6712fa6e436e476.svg";